import React from "react";
import "../pages/Auditor/ActivityModalV2.css";

function ConfirmModalV2({ onSubmit, onClose, yesText = 'Yes', noText = 'No', title, message, children }: any) {
  function submit() {
    onSubmit();
    onClose();
  }

  return (
    <div className="ae-confirm-overlay">
      <div className="ae-confirm-dialog">
        <div className="ae-confirm-head">
          <span className="ae-confirm-title">{title || 'Confirm'}</span>
          <button type="button" className="ae-confirm-close" onClick={onClose} aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <div className="ae-confirm-body">
          {message && <div dangerouslySetInnerHTML={{ __html: message }} />}
          {children}
        </div>
        <div className="ae-confirm-foot">
          <button type="button" className="ae-back" onClick={onClose}>{noText}</button>
          <button type="button" className="ae-submit" onClick={submit}>{yesText}</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModalV2;
